import React from 'react';
import { Icons, SVGIcon } from '../../../../../components/atoms/SVG';
import { GroupedAssignedPage } from '../../../../../types/api/connectedPages/IConnectedPage';
import { ICategory } from '../../../../../types/ICategory';

function getCategorieTitle(categories?: ICategory[]): string | null {
  if (categories && categories.length > 0) {
    return categories.map(category => category.title).join(', ');
  }
  return null;
}

export function categoriesToString(categories?: ICategory[]) {
  const allCategoryTitle = getCategorieTitle(categories);
  return allCategoryTitle
    ? <span className="connected-pages-graph__document-type font-regular-15-21">{allCategoryTitle}</span>
    : null;
}

export function getLabel(categories: ICategory[] | undefined, pageLinkName: any) {
  const titles = getCategorieTitle(categories);
  return `(${titles ? `${titles})` : ''}${pageLinkName}`;
}

export function getLabelScreenReader(categories: ICategory[] | undefined, pageLinkName: any, ariaLabelPrefix: any) {
  const titles = getCategorieTitle(categories);
  return `${pageLinkName} ${titles ? `(${ariaLabelPrefix}: ${titles})` : ''}`;
}

export const getIconForGroupedAssignedPage = (assignment: GroupedAssignedPage): SVGIcon => {
  switch (assignment.roleId) {
    case '>isResponsibleFor':
      return Icons.PAGE_TO_PAGE_ROLE_IS_RESPONSIBLE;
    case '<isResponsibleFor':
      return Icons.PAGE_TO_PAGE_ROLE_UNDER_RESPONSIBILITY;
    case '>executes':
      return Icons.PAGE_TO_PAGE_ROLE_EXECUTES;
    case '<executes':
      return Icons.PAGE_TO_PAGE_ROLE_IS_EXECUTED;
    case '>participatesAt':
      return Icons.PAGE_TO_PAGE_ROLE_PARTICIPATES;
    case '<participatesAt':
      return Icons.PAGE_TO_PAGE_ROLE_UNDER_PARTICIPATION;
    case '>isPartOf':
      return Icons.PAGE_TO_PAGE_ROLE_BELONGS_TO;
    case '<isPartOf':
      return Icons.PAGE_TO_PAGE_ROLE_CONTAINS;
    case '>precedes':
      return Icons.PAGE_TO_PAGE_ROLE_SUCCESSOR;
    case '<precedes':
      return Icons.PAGE_TO_PAGE_ROLE_PREDECESSOR;
    case '>isRelatedTo':
    case '<isRelatedTo':
      return Icons.PAGE_TO_PAGE_ROLE_RELATED;
    case '>complements':
      return Icons.PAGE_TO_PAGE_ROLE_CONTINUING;
    default:
      return Icons.SETTINGS;
  }
};
